import type {GridColDef, GridInitialState} from '@mui/x-data-grid-pro';

type ColumnDimensions = NonNullable<GridInitialState['columns']>['dimensions'];

/**
 * Sets stored widths on columns.
 * Grid resets widths from initialState to column widths when columns change, so columns get the stored widths too.
 */
export const applyColumnWidths = (
  columns: GridColDef[],
  dimensions: ColumnDimensions | undefined,
): GridColDef[] => {
  if (!dimensions || Object.keys(dimensions).length === 0) {
    return columns;
  }

  return columns.map(column => {
    const width = dimensions[column.field]?.width;

    return width === undefined ? column : {...column, width};
  });
};
